
export const PRIMARY_PRODUCT_TYPE = {
  AGGREGATE: 'AGGREGATE',
  CONCRETE: 'CONCRETE',
};

export const PRIMARY_PRODUCT_TYPES = Object.keys(PRIMARY_PRODUCT_TYPE)
